import { Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import Colors from '@constants/Colors';

type Props = {
    title: string;
    description?: string;
    children: React.ReactNode;
    showTitle?: boolean;
    optional?: boolean;
};

const FormSection = (props: Props) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={4} display={props.showTitle ? 'flex' : 'none'}>
                <Stack>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{
                            fontFamily: 'Lemon milk pro',
                            fontWeight: 'bold',
                            fontSize: 16,
                            color: Colors.NEUTRAL_DARK_GRAY,
                            display: 'inline',
                        }}
                    >
                        {props.title}
                        {props.optional && (
                            <Typography
                                component="span"
                                sx={{
                                    fontFamily: 'Lemon milk pro',
                                    fontWeight: 'bold',
                                    fontSize: 16,
                                    color: Colors.NEUTRAL_DARK_GRAY,
                                    display: 'inline',
                                }}
                            >
                                {' '}
                                (facultatif)
                            </Typography>
                        )}
                    </Typography>
                    {props.description && (
                        <Typography
                            sx={{
                                fontFamily: 'Lemon milk pro',
                                fontSize: 14,
                                color: Colors.NEUTRAL_DARK_GRAY,
                            }}
                        >
                            {props.description}
                        </Typography>
                    )}
                </Stack>
            </Grid>
            <Grid item xs={12} sm>
                {props.children}
            </Grid>
        </Grid>
    );
};

export default FormSection;
